// usernameRules.ts
//
// The shape of a username, as the server enforces it (supabase/functions/_shared/
// usernameRules.ts, which says why it is a security rule). This copy exists so the page can
// say what is allowed before a round trip. It is a courtesy: the server decides.
//
// Duplicated on purpose - a different runtime, like the error codes - and held equal by
// `pnpm -C apps/extension test:username`, which reads both patterns.

/**
 * 3 to 20 characters in all; letters and digits, with a single . _ or - only BETWEEN them.
 * The lookahead holds the length, the rest holds the shape.
 */
export const USERNAME_PATTERN = /^(?=.{3,20}$)[a-z0-9]+(?:[._-][a-z0-9]+)*$/;

export const USERNAME_RULE_TEXT = "Usernames are 3 to 20 letters and digits; a single dot, dash or underscore may sit inside.";

/** The same fold the server applies first: surrounding spaces off, lowercase. */
export function isValidUsername(raw: string): boolean {
  return USERNAME_PATTERN.test(raw.trim().toLowerCase());
}
